import { toast as sonnerToast } from "sonner";

// Track active toast IDs to prevent duplicates
const activeToasts = new Set();

const createToast = (type) => (message, options = {}) => {
  // Create a unique ID based on message and type
  const toastId = options.id || `${type}-${message}`;
  
  // If this toast is already showing, don't show again
  if (activeToasts.has(toastId)) {
    return toastId;
  }
  
  activeToasts.add(toastId);
  
  // Remove from tracking when toast is dismissed
  const onDismiss = () => {
    activeToasts.delete(toastId);
    if (options.onDismiss) options.onDismiss();
  };
  
  return sonnerToast[type](message, {
    ...options,
    id: toastId,
    onDismiss,
    onAutoClose: () => {
      activeToasts.delete(toastId);
      if (options.onAutoClose) options.onAutoClose();
    }
  });
};

export const toast = {
  success: createToast('success'),
  error: createToast('error'),
  info: createToast('info'),
  warning: createToast('warning'),
  loading: createToast('loading'),
  message: createToast('message'),
  // For custom toasts or when you need the original
  custom: sonnerToast,
  dismiss: sonnerToast.dismiss,
  promise: sonnerToast.promise,
};

export default toast;
